// extracted by mini-css-extract-plugin
export default {"imageWithTimeoutLoader":"imageWithTimeout_imageWithTimeoutLoader__03vPz","loader":"imageWithTimeout_loader__6uEjo"};